import React from "react";
import { Helmet, HelmetData } from "react-helmet-async";
import { motion } from "framer-motion";
import LazyLoad from "react-lazy-load";
// imported image
import Profile from "../img/profile.jpeg";
import ToTop from "./Subassets/ToTop";

// helmet context for meta tages and title
const helmetData = new HelmetData({});
const About = () => {
  return (
    <>
      <Helmet helmetData={helmetData}>
        <meta
          name="description"
          content="About me | Portfolio | inforamtion about me to know more about me contact me by filling the form."
        />

        <title>DevProfile | About</title>
      </Helmet>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, delay: 1 }}
        transition={{
          ease: "easeInOut",
          duration: 0.7,
          delay: 0.15,
        }}
      >
        <section
          aria-label="about me like my name about some works and other things"
          className="grid items-center mx-auto justify-center md:w-[95vw] 2xl:w-[98vw] min-h-screen px-5 py-20 bg-gray-900 backdrop-blur-sm backdrop-brightness-50 backdrop-sepia"
        >
          <article
            aria-label="about me as frontend developer"
            name="about"
            className="container pb-10 mx-auto text-gray-200"
          >
            <div className="flex justify-center w-full pb-20">
              <h1 className="mx-auto mb-4 text-4xl font-bold text-center underline rounded underline-offset-8 decoration-cyan-600">
                About
              </h1>
            </div>
            <div className="flex mx-auto scale-105 morph backdrop-blur-xl">
              <div className="grid items-center justify-center px-2 py-8 mx-auto sm:px-4 lg:flex lg:flex-row-reverse">
                <div className="grid items-center justify-center lg:pr-20">
                  <figure aria-label="about me my pic" className="">
                    <LazyLoad>
                      <img
                        src={Profile}
                        className="rounded-xl"
                        alt="Arun tiwari"
                      />
                    </LazyLoad>
                  </figure>
                </div>
                <div className=" md:pl-4 md:text-center lg:text-left lg:max-w-[60%] mx-auto">
                  <hgroup
                    aria-label="my intro or we also can say that about me"
                    className="grid justify-end md:gap-0 space-between"
                  >
                    <div className="py-4 text-2xl font-bold break-words md:text-4xl text-cyan-200">
                      <p
                        aria-label="Hi, I'm Arun, nice to meet you. Lets build something
                      special. "
                      >
                        Hi, I'm Arun, nice to meet you. Lets build something
                        special.
                      </p>
                    </div>

                    <p
                      className="break-words"
                      aria-label="Entry level front-end developer focusing on Javascript mobile-first development."
                    >
                      Passionate UI Developer creating seamless user experiences
                      with a diverse background in web development. With 6
                      months of internship experience in Laravel web development
                      and 8–9 months of frontend development experience, I have
                      honed my skills in basic frontend UI creation. Currently
                      thriving as a UI Developer at Webkul, I specializing in
                      Next.js, using Magento APIs to create things. I take pride
                      in my certifications in Meta Frontend Development,
                      Google's UX Design, and Google SEO, which have equipped me
                      with a well-rounded skill set. My expertise is crafting
                      responsive and headless UIs using cutting-edge
                      technologies like Tailwind and Material Design. I am
                      dedicated to designing visually captivating and
                      user-centric interfaces that drive engagement and enhance
                      usability. With an unwavering commitment to staying
                      updated on the latest industry trends and best practices,
                      I ensure that my designs are always modern, efficient, and
                      accessible. Along with these thing I developed some soft
                      skills as well in this period those are
                      leadership,teamwork,creativity,patience and many other
                      main skill from apart from these is I am a good listener
                      so i can understand problems easily.
                    </p>
                  </hgroup>
                </div>
              </div>
            </div>
          </article>
        </section>
        <ToTop name="about" />
      </motion.div>
    </>
  );
};

export default About;
